<script>import { ICON_STROKE_MAP } from "./";
export let size = 24;
</script>
<svg width={size} height={size} stroke-width={ICON_STROKE_MAP[size]} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}><path d="M3.25 7.75L7.25 3.75L11.25 7.75M12.75 16.25L16.75 20.25L20.75 16.25M7.25 5V20.25M16.75 3.75V19.25" stroke="currentColor" stroke-linecap="square"/></svg>